<template>
 <page>
  
  

  <head-nav :title="$t('language.page_parentspeak')">
    <icon-button-hamburger slot="left"></icon-button-hamburger>
    <icon-button-home slot="right"></icon-button-home>
  </head-nav>


  <scroll-page :pull-reload="true">

    <list-talks :group_id="0"/>

   </scroll-page>
  </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import ListTalks from '../components/talks/ListTalks';
import ScrollPage from '../components/ScrollPage.vue';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';

export default {
  name: 'list-talks-page',
  data:function(){
    return{
    }
  },
  computed:{
     ...mapState(['group','appSettings']),

  },
  components: {
    ListTalks,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
    Page,
    ScrollPage,
  },
  methods:{

    
  },// methods{}
  created(){
     
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
